export default [
    {
        name:"PEB",
        type:"glbModel",
        path:"/models/FinalModelMaking5.glb"
    }
]